
import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import '../../../assets/css/layoutMaster.css'
export const NuevoSelectAutocomplete = ({ options, valorInput, textoInput , valorPorDefecto, opcionTodos, opcionSeleccione }) => {
    const newArr = []
    if(opcionTodos){
        newArr.push({
            label: `-- Todos --`,
            value: 0
        })
    }
    
    if(opcionSeleccione){
        newArr.push({
            label: `--Seleccione--`,
            value: 0
        })
    }

    options.map(function(data){
        newArr.push(data)
    })

    options = newArr
    const opcionSeleccionada = options.find(e => e.value === valorPorDefecto)
    const defaultValue = opcionSeleccionada ? opcionSeleccionada : options[0]; // Valor por defecto
    const [selectedValue, setSelectedValue] = useState(defaultValue ? defaultValue :  options[0]);

    const funcionCambio = (selectedOption) => {
        setSelectedValue(selectedOption)
        valorInput(selectedOption.value)
        textoInput(selectedOption.value)
    };
    
    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px', // Define una altura máxima para el contenedor de opciones
            overflowY: 'auto',  // Agrega scroll vertical si el contenido excede la altura máxima
            backgroundColor:'rgba(39,39,42,255)'
        }),
        input: (provided) => ({
            ...provided,
            // marginTop:'-7px',
            cursor:'text',
            color:'white',
            fontSize:'13px',
            // border:'2px solid rgba(30,144,255,255)'
            // height:  '0px',
            
        }),
        control: (provided, state) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
            borderRadius: '5px',
            // width:'350px',
            height:  '30px',
            minHeight: '30px',
            // minHeight: '20px',
            border:'1px solid rgba(39,39,42,255)',
            backgroundColor: 'rgba(39,39,42,255)',
        }),
        placeholder:(provided)=>({
            color:'white',
            marginTop: '-35px',
            textAlign: 'center',
            width: '300px'
        }),
        singleValue: (provided) => ({
            ...provided,
            lineHeight: '30px', // Ajusta el valor según el alto deseado
            // marginTop:'-10px',
            fontSize:'14px',
            height:"30px",
            color: 'white',
            textAlign:'center'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
                '&::-webkit-scrollbar': {
                    width: '10px !important',   // Tamaño del scroll en vertical
                    height: '10px !important',  // Tamaño del scroll en horizontal
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#2e5289 !important', // Color del thumb del scrollbar
                    borderRadius: '10px !important',    // Radio del borde del thumb
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#5376ac !important',
                    boxShadow:' 0 0 2px 1px rgba(0, 0, 0, 0.2) !important'
                },
                '&::-webkit-scrollbar-thumb:active': {
                    backgroundColor: '#3e639b !important',
                },
                '&::-webkit-scrollbar-track':{
                    backgroundColor: '#474545 !important',
                }
            // marginTop:'-10px'
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            marginTop:'-1px',
            display: 'none',
            height:'30px'
        }),
        option: (provided,state) => ({
            ...provided,
            backgroundColor: state.isSelected ? 'rgba(30,144,255,255)' : 'rgba(39,39,42,255)',
            color: 'white',
            fontSize:'14px',
            '&:hover': {
                backgroundColor: 'rgba(30,144,255,255)',
            },
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 100000000,
        }),
        menu: () => ({
            backgroundColor:'rgba(39,39,42,255)'
        }),
        // valueContainer : () => ({

        // })
    };

    return (
        <Select 
            className=' containerScroll w-full'
            classNamePrefix='containerScroll'
            styles={customStyles}
            options={options} 
            placeholder="Selecciona una opción" 
            onChange={funcionCambio} 
            defaultValue={defaultValue} 
            value={selectedValue ? selectedValue : defaultValue} 
            menuPortalTarget={document.body}>
        </Select>
    );
};

